import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@erp/ui";

export interface ConflictDialogProps {
  open: boolean;
  /**
   * Load the latest server state: the caller invalidates the record's queries
   * and resets the form from fresh data (then clears `conflict`).
   */
  onReload: () => void;
  onDismiss: () => void;
}

/**
 * The standard 412 optimistic-concurrency UX: someone else changed the record
 * since it was loaded. Offer to reload (discarding local edits) or close and
 * let the user copy their changes out first.
 */
export function ConflictDialog({ open, onReload, onDismiss }: ConflictDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onDismiss();
        }
      }}
    >
      <DialogContent closeLabel={t("actions.close")}>
        <DialogHeader>
          <DialogTitle>{t("errors.conflictTitle")}</DialogTitle>
          <DialogDescription>{t("errors.conflictBody")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onDismiss}>
            {t("actions.close")}
          </Button>
          <Button type="button" onClick={onReload}>
            {t("actions.reload", "Reload")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
